import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import {
  FlexRowCenter,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { IconImg } from '../../Defaults/Icon/IconImg';
import { resolveCategoryUrl } from '../../../utilities/selectors';
import { IconType, SvgIcon } from '../General/SvgIcon';

export interface Props {
  id?: number;
  name: string;
  imgSrc?: string;
  url: string;
  onClick?: any;
  onClickLink?: any;
  showArrow?: boolean;
  isCurrent?: boolean;
}

function MobileNavSubItem({
  name,
  imgSrc = '',
  url,
  showArrow,
  onClickLink,
  onClick,
  id = 0,
  isCurrent,
}: Props) {
  const catUrl = resolveCategoryUrl(id, url);

  const onClickLastCategory = () => {
    onClick();
    if (!showArrow) {
      onClickLink();
    }
  };
  return (
    <Wrapper onClick={onClickLastCategory} to={showArrow ? undefined : catUrl}>
      <FlexRowCenterVertical>
        <ImageWrapper to={catUrl}>
          {imgSrc && imgSrc !== '' ? <Image src={imgSrc} /> : null}
        </ImageWrapper>
        <NameLink onClick={onClickLink} to={catUrl} isCurrent={isCurrent}>
          {name}
        </NameLink>
      </FlexRowCenterVertical>
      {showArrow && (
        <SvgIcon
          icon={IconType.rightArrow}
          alt="Späť"
          viewBox={'0 0 24 24'}
          width={16}
          height={16}
          cursor={'pointer'}
          fill={'#003366'}
          // tslint:disable-next-line:jsx-no-lambda
        />
      )}
    </Wrapper>
  );
}

const Wrapper = styled(Link)`
  text-decoration: none;
  line-height: ${rem(22)};
  padding: ${rem(16)};
  color: ${({ theme }) => theme.colors.textPrimary};
  background-color: ${({ theme }) => theme.colors.white};
  line-height: ${rem(22)};
  font-size: 14px;
  border-bottom: ${({ theme }) => theme.borders.primary};
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
  height: ${rem(48)};
  &:nth-child(2) {
    border-top: ${({ theme }) => theme.borders.primary};
  }
`;

const NameLink = styled(Link)<{ isCurrent?: boolean }>`
  font-family: 'Roboto', sans-serif;
  font-weight: ${({ isCurrent }) => (isCurrent ? '700' : '400')};
  font-size: ${rem(14)};
  text-decoration: none;
  color: #003366;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-transform: lowercase !important;
  :first-letter {
    text-transform: uppercase;
  }
`;

const ImageWrapper = styled(Link)`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  width: ${rem(24)};
  height: ${rem(24)};
  padding: ${rem(1)};
  margin-right: ${rem(12)};
  border-radius: ${rem(2)};
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;

export { MobileNavSubItem };
